import { NgIf } from '@angular/common';
import { Component, forwardRef, Input } from '@angular/core';

import { Alert } from '@app/client/alerts/state/alerts-state.models';
import { AlertSeverity } from '@app/client/settings/user/modules/alert-settings/alert-settings.model';
import { StatusIconColors, StatusIconComponent } from '@app/shared/components/status-icon/status-icon.component';
import { SharedDirectivesModule } from '@app/shared/shared-directives.module';

@Component({
  selector: 'adspt-alerts-severity-icon',
  templateUrl: './alerts-severity-icon.component.html',
  styleUrls: ['./alerts-severity-icon.component.scss'],
  imports: [forwardRef(() => SharedDirectivesModule), NgIf, StatusIconComponent],
})
export class AlertsSeverityIconComponent {
  @Input()
  alert?: Alert;

  @Input()
  size = 24;

  get color(): StatusIconColors {
    return {
      [AlertSeverity.Info]: 'blue' as const,
      [AlertSeverity.Warning]: 'yellow' as const,
      [AlertSeverity.Critical]: 'red' as const,
    }[this.alert?.severity];
  }
}
